"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveStateLevel = exports.autoCompleteAnswer = exports.handleCheckString = void 0;
const local_storage_1 = require("../../../../utils/local-storage");
const create_jumpled_strings_1 = require("./elements/create-jumpled-strings");
const drag_and_drop_card_1 = require("./elements/drag-and-drop-card");
const playUI_1 = require("./playUI");
let numcheck = 0;
let autoCompleteCountes = 0;
function createNewLevelRound() {
    var _a;
    const curRound = Number((0, local_storage_1.getCurrentState)().round);
    const curLevel = Number((_a = (0, local_storage_1.getCurrentState)().level) === null || _a === void 0 ? void 0 : _a.split('').slice(-1).join(''));
    const counter = document.getElementById('counter');
    const nextPlayUI = new playUI_1.PlayUI('game-start');
    const playBoard = document.getElementById('play-board');
    const currentLevel = document.getElementById('game-start');
    const buttonBar = document.getElementById('button-bar');
    autoCompleteCountes = 0;
    if (curRound < 44) {
        const newRound = curRound + 1;
        const nextRound = nextPlayUI.render(`Level${curLevel}`, newRound);
        nextRound.style.position = 'static';
        currentLevel.remove();
        playBoard.insertBefore(nextRound, buttonBar);
        counter.innerText = `${autoCompleteCountes}`;
    }
    else if (curLevel < 7) {
        const nextLevelNum = curLevel + 1;
        const nextLevel = nextPlayUI.render(`Level${nextLevelNum}`, 0);
        nextLevel.style.position = 'static';
        currentLevel.remove();
        playBoard.insertBefore(nextLevel, buttonBar);
        counter.innerText = `${autoCompleteCountes}`;
    }
}
function createNewOutput() {
    const currentOutput = document.getElementById('current-output');
    const outputDataBlock = document.getElementById('output-data-block');
    const checkButton = document.getElementById('check-level-button');
    currentOutput.id = 'output';
    const newOutput = document.createElement('div');
    newOutput.id = 'current-output';
    newOutput.className = 'output';
    checkButton.classList.remove('hidden');
    checkButton.classList.add('disable');
    outputDataBlock.append(newOutput);
}
function checkString() {
    const target = document.getElementById('check-level-button');
    const buttonAutoComplete = document.getElementById('auto-complete-button');
    const currentOutput = document.getElementById('current-output');
    const source = document.getElementById('source-data-block');
    const currentString = create_jumpled_strings_1.JumpledStrings.currentString;
    const answerString = [];
    const wrongWord = [];
    const wordPArray = currentOutput.querySelectorAll('#word-p');
    wordPArray.forEach((wordp) => {
        const word = wordp.textContent;
        if (word) {
            answerString.push(word);
        }
    });
    answerString.every((elem, index) => {
        if (elem !== currentString.split(' ')[index]) {
            wrongWord.push(elem);
        }
        return wrongWord;
    });
    if (!wrongWord.length) {
        target.textContent = 'Continue';
        target.classList.add('continue');
        target.classList.remove('disabled');
        currentOutput.classList.add('output-end');
        buttonAutoComplete.classList.add('disabled');
        source.innerHTML = '';
        wordPArray.forEach((wordp) => {
            wordp.classList.add('no-pointer-events');
            wordp.classList.remove('word-p-wrong');
            wordp.classList.add('word-p-end');
        });
        numcheck = 1;
    }
    else {
        wordPArray.forEach((wordp) => {
            const word = wordp.textContent;
            if (word) {
                if (wrongWord.includes(word)) {
                    wordp.classList.add('word-p-wrong');
                }
            }
        });
    }
}
function createNextRound() {
    let roundNUM = playUI_1.PlayUI.roundStringNumber;
    const target = document.getElementById('check-level-button');
    const buttonAutoComplete = document.getElementById('auto-complete-button');
    if (roundNUM < playUI_1.PlayUI.sourceStringArray.length - 1) {
        roundNUM += 1;
        playUI_1.PlayUI.roundStringNumber = roundNUM;
        const sourceDataBlock = document.getElementById('source-data-block');
        const parent = sourceDataBlock.parentNode;
        parent === null || parent === void 0 ? void 0 : parent.removeChild(sourceDataBlock);
        createNewOutput();
        const dataBlock = new create_jumpled_strings_1.JumpledStrings('source-data-block');
        const newSourceDataBlock = dataBlock.render(`<${playUI_1.PlayUI.sourceStringArray[roundNUM]}>`);
        parent === null || parent === void 0 ? void 0 : parent.append(newSourceDataBlock);
        target.textContent = 'Check';
        target.classList.remove('continue');
        target.classList.add('disabled');
        buttonAutoComplete.classList.remove('disabled');
        numcheck = 0;
    }
    else {
        createNewLevelRound();
        target.textContent = 'Check';
        target.classList.remove('continue');
        target.classList.add('disabled');
        buttonAutoComplete.classList.remove('disabled');
        numcheck = 0;
    }
}
function handleCheckString() {
    if (numcheck === 1) {
        createNextRound();
    }
    else {
        checkString();
    }
}
exports.handleCheckString = handleCheckString;
function autoCompleteAnswer() {
    autoCompleteCountes += 1;
    const currentString = create_jumpled_strings_1.JumpledStrings.currentString;
    const currentOutput = document.getElementById('current-output');
    const counter = document.getElementById('counter');
    currentOutput.innerHTML = '';
    currentString.split(' ').forEach((word) => {
        const wordP = document.createElement('p');
        wordP.className = 'word-p';
        wordP.id = 'word-p';
        wordP.innerText = word;
        wordP.draggable = true;
        currentOutput.append(wordP);
        wordP.addEventListener('mouseup', drag_and_drop_card_1.clickCards);
    });
    checkString();
    counter.innerText = `${autoCompleteCountes}`;
}
exports.autoCompleteAnswer = autoCompleteAnswer;
function saveStateLevel(level, round) {
    (0, local_storage_1.setCurrentState)(level, round);
}
exports.saveStateLevel = saveStateLevel;
